import { render, staticRenderFns } from "./BtnToTop.vue?vue&type=template&id=df43dd00&scoped=true"
import script from "./BtnToTop.vue?vue&type=script&lang=js"
export * from "./BtnToTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df43dd00",
  null
  
)

export default component.exports